export default __webpack_public_path__ + "static/aid_character_correct-dcfa0d9b85c8961cc95da5dc177c6929.svg";